import { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { isMobile } from "react-device-detect";
import { useEditorWebsocket } from "@hooks";
import {
  useEstimatePresetStore,
  useEstimateEditorStore,
  useFonts,
  useEstimateComments,
  useLocationHash,
  EditorRoot,
  ProposalAppBar,
  EstimateStructureProvider,
} from "@tools";
import { AppContainer } from "@components";
import { onPatch } from "mobx-state-tree";

export const ProposalView = observer(() => {
  const editorStore = useEstimateEditorStore();
  const presetStore = useEstimatePresetStore();
  const commentStore = useEstimateComments();
  const socket = useEditorWebsocket();
  const { loadFonts, unloadFonts } = useFonts();
  const { handleLocationHash } = useLocationHash();

  const { currentEstimateStructure, pdfDocument, noTurningOff } = editorStore;
  const { selectedPresetFont } = presetStore;
  
  const commentActionListener = useRef();
  
  useEffect(() => {
    socket?.initSocket();
    
    handleLocationHash();
    // const defaultVersionKey = handleLocationHash();
    // if(defaultVersionKey)
    //   editorStore.setCurrentVersion(defaultVersionKey);
    
    commentStore.initHistoryManager();
    commentActionListener.current?.();
    commentActionListener.current = onPatch(
      commentStore,
      ({ path, value }) => {
        if(path.match(/\/historyManager\/history\/\d+/) && value?.patches) {
          socket.requestCommentPatch(value.patches);
        }
      }
    )
    
    return () => {
      commentActionListener.current?.();
    }
  }, []);
  
  useEffect(() => {
    if(selectedPresetFont)
      loadFonts([selectedPresetFont])
    
    return () => {
      unloadFonts();
    }
  }, [editorStore.currentVersionKey]);
  
  // usePresetStyles(presetStore?.selectedPresetData, presetStore?.selectedPresetFont);

  return (
    <EstimateStructureProvider value={currentEstimateStructure}>
      <ProposalAppBar isProposal />
      <AppContainer useViewportResizeObserver={isMobile}>
        <EditorRoot
          // readOnly
          isProposal
          allowInteractions
          showPdfCover={!!pdfDocument}
          noTurningOff={noTurningOff}
        />
      </AppContainer>
    </EstimateStructureProvider>
  );
});